"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _styles = _interopRequireDefault(require("./styles.scss"));
var className = _styles.default['helptip-container'];
var HelpTip = function HelpTip(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    style: props.style
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: props.isSingleLine ? 'helptip single-line' : 'helptip'
  }, props.children ? props.children : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faQuestion
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "tooltiptext",
    style: props.position
  }, props.content)));
};
HelpTip.propTypes = {
  children: _propTypes.default.element,
  content: _propTypes.default.string.isRequired,
  isSingleLine: _propTypes.default.bool,
  style: _propTypes.default.shape({}),
  position: _propTypes.default.shape({
    top: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    bottom: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    left: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    right: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  })
};
HelpTip.defaultProps = {
  children: undefined,
  isSingleLine: false,
  position: {},
  style: {}
};
var _default = HelpTip;
exports.default = _default;